import React, { Component } from "react";
import TopBar from "../../component/projectDetail/TopBar";
import Banner from "../../component/projectDetail/Banner";
import { connect } from "react-redux";
import * as _ from "lodash";
import { authService } from "../../../auth";
import DonationTargetComponent from "../../../Donation/DonationTargetComponent";
import { convertUnicode, getCDNUrl } from "../../../commons/CommonFunctions";
import Follow from "../../../commons/Follow";
import { setProjectDetails } from "../../../reducer/showAllReducer";
import ProjectTopContributorSection from "./ProjectTopContributorSection";
import ProjectHashTagsSection from "./ProjectHashTagsSection";
import { disclaimerText } from "../../../Donation/DonationCommonFunction";
import DonationAboutSection from "../../../Donation/DonationAboutSection";
import uuid from "react-uuid";
import { NavLink } from "react-router-dom";
import FeaturePostSection from "../../../profile/container/profile/FeaturePostSection";
import DonationCollectedSection from "../../../Donation/DonationCollectedSection";
import { Redirect, withRouter } from "react-router-dom";
import RightPanel from "../../component/projectDetail/RightPanel";
import { renderTaggedUsers,options } from "../../../explore/HashTags/Common/HashtagsCommonFunction";
import { renderToString } from "react-dom/server";
import ReactHtmlParser from "react-html-parser";
import Linkify from "react-linkify";
import stripHtml from "string-strip-html";
import OrganizationAdmin from "../../../commons/OrganizationAdmin";
import CleverTapUtils from "../../../commons/CleverTapUtils";

class ProjectHomeContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            donationBar: this.props.projectDetail?.donation,
            projectValue: {
                shortBrief: "",
                noOfParticipants: 0,
                noOfResearches: 0,
                feedbackCount: 0,
                companyName: "",
                location: {},
                creatorUserId: "",
                followed:false,
                imageUrl:'',
                creatorBannerImage:'',
                customUrl:'',
                partyType: '',
                params : []
            },
            isShowDonationData: true,
            entityConfigData: {},
            donateNowConfig: {},
        }
        this.updateDonationtargetKey = uuid();
    }

    setProjectDetails = function (projectDetails) {
        CleverTapUtils.eventClick({}, "Display Event Details");
        window.$('#projectDetails').modal('show');
        this.props.setProjectDetails(projectDetails);
    }

    componentDidMount() {
        if (this.props.projectDetail && this.props.projectDetail.isApproved != undefined) {
            this.setProjectValue(this.props);
        }
    }

    componentWillReceiveProps(props) {
        if (props.projectDetail && props.projectDetail.isApproved != undefined) {
            this.setProjectValue(props);
        }
    }

    setProjectValue = (props) => {
        let participationDetails = props.projectDetail.participationDetails;
        let project = props.projectDetail.project;
        let customUrl = this.props.projectDetail.customUrl;
        let partyType = this.props.projectDetail.partyType;
        let params = this.props.projectDetail.params;
        let userDeactivated = this.props.projectDetail.deactivated;
        let imageUrl=props.projectDetail.imageUrl;

        let proj = props.projectDetail.project;

        let participationCount = participationDetails.participationCount;
        let noOfParticipant = participationDetails.noOfParticipant;
        let shortBrief = project.shortBrief;
        let creatorUserId = project.userId;
        let followed = props.projectDetail.followed;
        let location = project.location;
        let postedBy = participationDetails.postedBy;

        this.setState({
            projectValue: {
                ...this.state.projectValue,
                noOfParticipants: noOfParticipant || participationCount,
                shortBrief,
                location,
                creatorUserId,
                followed,
                companyName: postedBy,
                imageUrl,
                customUrl,
                partyType,
                params,
                userDeactivated
            }
        });
    };

    getEntityDonationConfig = (config) => {
        this.setState({
            donateNowConfig: config
        })
    }

    getDonationConfig = (config) => {
        this.setState({
            entityConfigData: config
        })
    }

    onSuccessDonationTargetUpdate = (donationBarData) => {
        this.updateDonationtargetKey = uuid();
        this.setState({
            donationBar: donationBarData
        })
    }

    redirectToProfile = (customUrl, partyType) => {
        window.location.href = partyType !== "CIRCLE" ? `/profile/${customUrl}` : `/community/${customUrl}`;
    }

    hideDonationData = () => {
        this.setState({
            isShowDonationData: false
        })
    }

    render() {
        const { donateNowConfig, donationBar, entityConfigData, isShowDonationData } = this.state;
        let linkifiedHtml =
            '<p class="pdtlsLink">' +
            renderTaggedUsers(renderToString(
                <Linkify
                    componentDecorator={(
                        decoratedHref,
                        decoratedText,
                        key
                    ) => (
                        <a
                            target="blank"
                            href={decoratedHref}
                            key={key}
                        >
                            {decoratedText}
                        </a>
                    )}
                >
                    {this.state.projectValue.shortBrief
                        ? stripHtml(this.state.projectValue.shortBrief)
                        : ""}
                </Linkify>
            )) +
            "</p>";
        linkifiedHtml = renderToString(
            ReactHtmlParser(linkifiedHtml, options)
        );
        return (
            <div className="col-md-9">
                <div className="projectinn nothidden projdetailscont">
                    <Banner {...this.props} key={this.updateDonationtargetKey} needDonationConfig={true} getEntityDonationConfig={this.getEntityDonationConfig} getDonationConfig={this.getDonationConfig} pageType={"HOME"} donationBar={donationBar}  />
                    {this.props.projectDetail &&
                        !_.isUndefined(this.props.projectDetail.demolished) &&
                        this.props.projectDetail.demolished === false && (
                            <TopBar {...this.props} />
                        )}

                    {this.props.userId && <OrganizationAdmin userId={this.props.userId} />}

                    <div className="projdetlswrap">
                        <div className="projdtlsHomePage">
                            <div className="row" style={{marginBottom: '20px'}}>
                                <div className="col-lg-9">
                                    <div className="projHmBrifDesc dgcard">
                                        <h4 className="title">Brief description</h4>
                                        {/* <p>{this.state.projectValue && this.state.projectValue.shortBrief.split("\\n").map(brief => (<>{convertUnicode(brief)}<br/></>))}</p> */}                             
                                        {this.state.projectValue.shortBrief && this.state.projectValue.shortBrief !== "" && (<p dangerouslySetInnerHTML={{ __html: linkifiedHtml}}/>)}                              
                                        <div className="projHmMiscInfo">
                                            {isShowDonationData && this.props.projectDetail?.project?.type !== "JOB" && !_.isEmpty(donateNowConfig) &&
                                                <div className="prjHmpostedBy">
                                                    <span className="label">Posted by</span>
                                                    <div className="projhead">
                                                        <figure className="complogo" onClick={(e) => {
                                                            e.preventDefault();
                                                            this.redirectToProfile(this.state.projectValue.customUrl , this.state.projectValue.partyType)
                                                        }} style={{cursor:'pointer'}}>
                                                            <img src={this.state.projectValue && this.state.projectValue.imageUrl ? getCDNUrl(this.state.projectValue.imageUrl):(this.state.projectValue.partyType == "CIRCLE" ? "https://cdn.dscovr.com/images/circleDefault.webp" :  this.props.projectDetail.userType == "INDIVIDUAL" ? "https://cdn.dscovr.com/images/users1.png" : "https://cdn.dscovr.com/images/DefaultBusiness.png")} onError={(e)=>{e.target.onerror = null; e.target.src="https://cdn.dscovr.com/images/circleDefault.png"}}  alt=""/>
                                                        </figure>
                                                        <div>
                                                        <a onClick={(e) => { e.preventDefault(); this.redirectToProfile(this.state.projectValue.customUrl, this.state.projectValue.partyType) }} >
                                                            <h5>{this.state.projectValue && this.state.projectValue.companyName}</h5></a>
                                                            {(this.state.projectValue && this.state.projectValue.creatorUserId && this.state.projectValue.partyType!= "CIRCLE" && !this.state.projectValue.userDeactivated) ?
                                                                <Follow userId={this.state.projectValue && this.state.projectValue.creatorUserId} followed={this.state.projectValue && this.state.projectValue.followed}/>  : null
                                                            }
                                                            {this.state.projectValue && this.state.projectValue.location && this.state.projectValue.location.city &&
                                                            <span className="address">
                                                                {this.state.projectValue.location.city + ", " + this.state.projectValue.location.state + ", " + this.state.projectValue.location.country}
                                                            </span>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            {this.props.projectDetail && this.props.projectDetail.participationDetails && 
                                                <div className="prjHmApplicantCount">
                                                    <i className="iParticipants"></i>
                                                    {this.state.projectValue?.noOfParticipants} {this.props.projectDetail?.participationDetails?.secondaryEntityType === 'FUNDRAISE' ? "Contributor" : "Applicant"}{this.state.projectValue.noOfParticipants > 1 && "s"}
                                                </div>
                                            }
                                            <div className="prjHmKnowMoreButt">
                                                <button type="button" className="btn" onClick={(e) => this.setProjectDetails(this.props.projectDetail)}>Know More</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {isShowDonationData && this.props.projectDetail?.project?.type !== "JOB" && !_.isEmpty(donateNowConfig) ?
                                    <div className="col-lg-3">
                                        <div className="prjHmDonationInfoBox dgcard">
                                            {this.props.projectDetail?.id && !_.isEmpty(donateNowConfig) &&
                                                <DonationCollectedSection donateNowConfig={donateNowConfig} entityConfigData={entityConfigData} entityId={this.props.projectDetail?.id} entityType={"PROJECT"} hideDonationData={this.hideDonationData} changeTab={this.props.changeTab} />
                                            }
                                            {donateNowConfig?.id && donateNowConfig?.manageDataPermission && donationBar?.donateActive && 
                                                <div className="text-center">
                                                    <DonationTargetComponent donateNowConfig={donateNowConfig} indian={entityConfigData?.indian} donationBarData={donationBar} onSuccessDonationTargetUpdate={this.onSuccessDonationTargetUpdate} />
                                            </div>}
                                        </div>
                                    </div> :
                                    <RightPanel {...this.props} isDonationData={true} />
                                }
                            </div>

                            {this.props.projectDetail?.id &&
                                <>
                                    <FeaturePostSection userId={this.props.projectDetail?.id} />
                                    <ProjectTopContributorSection entityId={this.props.projectDetail?.id} />
                                    <ProjectHashTagsSection entityId={this.props.projectDetail?.id} />
                                </>
                            }

                            {this.props.projectDetail?.donation?.donateActive && !_.isEmpty(donateNowConfig) &&
                                <>
                                    <DonationAboutSection donateNowConfig={donateNowConfig} entityId={this.props.projectDetail?.id} entityType={"PROJECT"} />
                                    <div className="prjHmDisclaimer">
                                        <p><span>Disclaimer</span> : {disclaimerText("PROJECT")}</p>
                                    </div>
                                </>
                            }
                            {this.props.projectDetail && this.props.projectDetail?.pendingInvitation &&
                                <div className="circBecomeMember" style={{border: 'none'}}>
                                    <NavLink to={{pathname: "/manage-invitation", state: {activeTab: "PROJECT"}}}
                                            className="btn bcmemb fixed"> Accept Invitation</NavLink>
                                </div>
                            }
                            {/* {!isShowDonationData && !this.props.projectDetail?.project?.type !== "JOB" &&
                            <div className="d-lg-none">
                                <div className="projdtlsfeedswidgetbott links">
                                    <NavLink exact to="/PrivacyPolicy">Privacy Policy</NavLink> <span>|</span>
                                    <NavLink exact to="/TermsConditions">Terms & Conditions</NavLink> <span>|</span>
                                    <NavLink exact to="/CookiePolicy" >Cookie Policy</NavLink>
                                </div>

                                <div className="projdtlsfeedswidgetbott">
                                    All Rights Reserved. <br/>
                                    2019 © Dscovr Journeys
                                </div>
                            </div>
                            } */}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        project: state.showAllReducer.projectDetails,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setProjectDetails: (projectDetails) =>
            dispatch(setProjectDetails(projectDetails)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectHomeContainer);
